import { Mail } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { PortalShell } from "../components/PortalShell";

export default function PortalSentPage() {
  const loc = useLocation() as any;
  const email: string | undefined = loc.state?.email;

  return (
    <PortalShell narrow>
      <div className="portal-login">
        <div className="portal-login-card" style={{ textAlign: "center" }}>
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              background: "var(--ne-red-soft)",
              color: "var(--ne-red)",
              display: "grid",
              placeItems: "center",
              margin: "4px auto 0",
            }}
          >
            <Mail size={26} />
          </div>
          <h1>Check your email</h1>
          <p className="portal-sub on-card">
            If an account exists for{" "}
            <strong style={{ color: "var(--ne-text)" }}>
              {email || "that address"}
            </strong>
            , we just sent you a one-tap sign-in link.
          </p>
          <p className="portal-sub on-card" style={{ fontSize: 13 }}>
            The link is good for the next 15 minutes. You can close this window
            once you tap it on your phone — it'll log you in there.
          </p>
          <div
            style={{
              borderTop: "1px solid var(--ne-silver-4)",
              paddingTop: 16,
              marginTop: 4,
            }}
          >
            <p className="portal-sub on-card" style={{ fontSize: 12, marginBottom: 6 }}>
              Wrong email?
            </p>
            <Link to="/portal/login" className="portal-btn-link on-card">
              Try again
            </Link>
          </div>
        </div>
      </div>
    </PortalShell>
  );
}
